import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmp2la0xefc/layouts/custom.vue").then(m => m.default || m))
}